import { useCallback, useEffect, useRef } from 'react';
import { HpModifiableUserInteraction } from '@zg-rentals/ts-hotpads-api-client';
import { useAddUserInteraction } from './useUserInteractions';
import { useCurrentUser } from './useUserQuery';

export function useDeferredViewedListingMutation(): (alias: string) => void {
  const { data: currentUser } = useCurrentUser();
  const { mutate: addUserInteraction } = useAddUserInteraction();
  const pendingAliasesRef = useRef(new Set<string>());

  const addViewInteraction = useCallback(
    (listingAlias: string) => {
      addUserInteraction({ postData: { interaction: HpModifiableUserInteraction.VIEW, listingAlias } });
    },
    [addUserInteraction],
  );

  useEffect(() => {
    if (currentUser === undefined || pendingAliasesRef.current.size === 0) return;

    const pendingAliases = Array.from(pendingAliasesRef.current);
    pendingAliasesRef.current.clear();
    if (!currentUser?.loggedIn) return;

    for (const alias of pendingAliases) {
      addViewInteraction(alias);
    }
  }, [currentUser, addViewInteraction]);

  return useCallback(
    (alias: string) => {
      if (currentUser === undefined) {
        pendingAliasesRef.current.add(alias);
        return;
      }

      if (currentUser?.loggedIn) {
        pendingAliasesRef.current.delete(alias);
        addViewInteraction(alias);
      }
    },
    [currentUser, addViewInteraction],
  );
}
